<app-owl-carousel-child #owl [ngClass]="carouselClasses" [options]="options">
    <ng-content></ng-content>
</app-owl-carousel-child>
